import React from 'react';
import { App as AntdApp } from 'antd';
import ReactDOM from 'react-dom/client';
import './index.css';
import './wsc-react-customform.css'
import reportWebVitals from './reportWebVitals';

import Root from './containers/root';
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
   <AntdApp>
     <Root />
  </AntdApp>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
